import React from 'react'; // eslint-disable-line
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _actions from '../../actions';
import LargeLoading from '../../components/svg/LargeLoading';
import apiClient from '../../config/axiosConfig';

class LoggedOut extends React.Component {
    componentDidMount() {
        // Use axios client to call logout endpoint
        apiClient.get('/logout', {
            headers: {
                'X-Session-Id': sessionStorage.getItem("SessionId")
            }
        })
            .then((response) => {
                // Logout successful
                this.props.actions.logout();
                localStorage.clear();
                window.location = response.data;
            })
            .catch((error) => {
                // Even if logout call fails, still proceed since we've already cleared local storage
                console.error('Logout API call failed:', error);
            });
    }

    render() {
        return (
            <div className="logged-out">
                <LargeLoading />
            </div>

        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoggedOut);
